import React, { useEffect } from 'react';
import { defaultHeroBackgroundImage } from './utils/defaultHeroBackgroundImage';
import { testSeePreview } from 'utils/intellimize';
import HeroCopy from 'components/Hero/HeroCopy';
import HeroSocialProof from './HeroSocialProof';
import HeroFeaturedContent from './HeroFeaturedContent';
import HeroContextualCTA from './HeroContextualCTA';
import colorTypeHelper from 'utils/colorTypeHelper';
import { heroReviews } from './utils/heroReviews';
import WistiaVideo from 'components/WistiaVideo';

import { SectionCol, SectionRow, StyledSectionLayout } from './styles';

const DynamicHero = ({
  customInlineForm,
  dataPosition,
  formType,
  data,
  images,
  intellimizeForm,
  seo,
  ...otherProps
}) => {
  const {
    background,
    backgroundImage,
    contentLeftAligned,
    contextualCta,
    featuredContent,
    featuredContentPosition,
    heading1,
    headingKicker1,
    headingKickerImage,
    popupVideo,
    socialProof,
    subhead,
    textColor,
  } = data || {};
  const { pageUrl, showBreadcrumbs } = seo || {};
  let featuredContentVariation;
  let fullWidthContent;
  const centerVertically = featuredContentPosition === 'Center Vertically';
  const defaultBackgroundImage = defaultHeroBackgroundImage(images, background);
  const reviews = heroReviews(images, background);
  const heroDesktopBackgroundImage = backgroundImage?.image || defaultBackgroundImage;
  const heroMobileBackgroundImage = backgroundImage?.imageMobile;
  const backgroundColor = colorTypeHelper[background];
  const showInlineForm = !(contextualCta && !customInlineForm);

  if (contentLeftAligned) {
    fullWidthContent = false;
  } else if (
    !featuredContent ||
    (featuredContent && featuredContentPosition === 'Bottom Overlay')
  ) {
    fullWidthContent = true;
  }

  if (featuredContent) {
    featuredContentVariation = featuredContentPosition !== 'Bottom Overlay' ? 'side' : 'bottom';
  }

  const fullWidthStyles = {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  };
  const centerVerticallyStyles = {
    height: 'auto',
  };

  const HeroContent = (
    <>
      <HeroCopy
        subhead={subhead}
        heading={heading1}
        headingKicker={headingKicker1}
        headingKickerImage={headingKickerImage}
        background={backgroundImage ? 'Custom' : background}
        featuredContentPosition={featuredContentPosition}
        fullWidthContent={fullWidthContent}
        textColor={textColor}
      />
      {!showInlineForm && (
        <HeroContextualCTA
          content={contextualCta}
          intellimizeForm={intellimizeForm}
          contentLeftAligned={contentLeftAligned}
          fullWidth={fullWidthContent}
        />
      )}
      {customInlineForm}
      {socialProof && (
        <HeroSocialProof reviews={reviews} background={backgroundImage ? 'Custom' : background} />
      )}
      {popupVideo && (
        <WistiaVideo {...{ ...popupVideo, label: popupVideo.label || 'Play Video' }} />
      )}
    </>
  );

  useEffect(() => {
    testSeePreview();
  }, []);

  return (
    <>
      <StyledSectionLayout
        bgColor={backgroundColor}
        desktopBgImage={heroDesktopBackgroundImage?.file?.url}
        mobileBgImage={heroMobileBackgroundImage?.file?.url}
        $contentLeftAligned={contentLeftAligned}
        innerContainerStyles={
          featuredContentVariation === 'bottom' &&
          'dynamic-hero-bottom-featured-content--inner-container'
        }
        {...otherProps}
      >
        <SectionRow
          type="flex"
          justify={contentLeftAligned ? 'start' : 'center'}
          gutter={80}
          $showBreadcrumbs={showBreadcrumbs}
          className={`test-${showInlineForm ? 'inline' : 'modal'}-hero`}
        >
          <SectionCol
            lg={fullWidthContent ? 24 : 12}
            md={fullWidthContent ? 24 : 12}
            sm={fullWidthContent ? 24 : 12}
            xs={24}
            $contentLeftAligned={contentLeftAligned}
            style={
              (fullWidthContent && fullWidthStyles) || (centerVertically && centerVerticallyStyles)
            }
          >
            {centerVertically ? (
              <div className="hero-featured-content--center-vertically">
                <div className="hero-featured-content--content">{HeroContent}</div>
              </div>
            ) : (
              HeroContent
            )}
          </SectionCol>
          {featuredContentVariation === 'side' && (
            <HeroFeaturedContent
              featuredContentPosition={featuredContentPosition}
              content={featuredContent}
              contentLeftAligned={contentLeftAligned}
              slug={pageUrl}
              hero
            />
          )}
        </SectionRow>
      </StyledSectionLayout>
      {featuredContentVariation === 'bottom' && (
        <HeroFeaturedContent
          featuredContentPosition={featuredContentPosition}
          content={featuredContent}
          contentLeftAligned={contentLeftAligned}
          slug={pageUrl}
        />
      )}
    </>
  );
};
export default DynamicHero;
